export default __webpack_public_path__ + "static/media/Pillar_Top.256.792ce1d8.png";